export const AircraftTypeExcelHeader = [
  {
    header: "AircraftType CODE",
    key: "AircraftType CODE",
    width: 25,
  },
  {
    header: "AircraftType NAME",
    key: "AircraftType CODE",
  },
  {
    header: "CREATED BY",
    key: "CREATED BY",
  },
  {
    header: "CREATED DATE",
    key: "CREATED DATE",
  },
];

export const AircraftTypeExcelName = "AircraftType List";
